module.exports = __webpack_public_path__ + "static/image/history/pc/201510.ver2_0_2.jpg?943faabf";